import React from "react";

/**
 * Dharma Wheel (Ashoka Chakra inspired) SVG with optional spin animation.
 * Navy ring, gold spokes on light; invertible with props.
 */
export default function DharmaWheel({
  size = 200,
  color = "#CFA052",
  ringColor = "#001B3A",
  spin = false,
  className = "",
}) {
  const spokes = Array.from({ length: 24 });
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={`${className} ${spin ? "animate-wheel-spin" : ""}`}
      aria-hidden="true"
    >
      <circle cx="100" cy="100" r="95" fill="none" stroke={ringColor} strokeWidth="3" />
      <circle cx="100" cy="100" r="82" fill="none" stroke={color} strokeWidth="1.5" opacity="0.6" />
      <circle cx="100" cy="100" r="16" fill={ringColor} />
      <circle cx="100" cy="100" r="6" fill={color} />
      {spokes.map((_, i) => {
        const angle = (i * 360) / 24;
        return (
          <line
            key={i}
            x1="100"
            y1="100"
            x2="100"
            y2="18"
            stroke={color}
            strokeWidth="1.2"
            transform={`rotate(${angle} 100 100)`}
          />
        );
      })}
    </svg>
  );
}
